
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
// import './style.css'
// import './bootstrap-overides.scss';
import { createApp } from 'vue';
import App from './App.vue';

createApp(App).mount('#app');
